module.exports = __webpack_public_path__ + "img/94.1b100ad0.jpg";